import { render } from "./MainCategory.vue?vue&type=template&id=6c6c0f1e&scoped=true"
import script from "./MainCategory.vue?vue&type=script&lang=js"
export * from "./MainCategory.vue?vue&type=script&lang=js"

import "./MainCategory.vue?vue&type=style&index=0&id=6c6c0f1e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c6c0f1e"]])

export default __exports__